export const planTypes = {
  INDIVIDUAL: "individual",
  FREELANCER: "freelancer",
  AGENCY: "agency",
};

export const UnlimitedPlanValue = "10000000000"; // 10 billion, used to represent unlimited in the UI